import "./index.scss";
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { faBrands, faFacebook } from "@fortawesome/react-fontawesome";
function Footer() {   
    return (
        <div className="footer_container">
            <div className="name">
                <p>台北科技大學區塊鏈研究社 Copyright © 2022 NTUT Blockchain Club. All rights reserved.</p>
                {/* <h2>社群媒體</h2>
                <FontAwesomeIcon icon="faFacebook" />     */}
                </div>

        </div>
    );
}

export default Footer;